import { useSites } from '../hooks/useSites';
import { useDeleteMedia, useMediaList, useUploadMedia } from '../hooks/useMedia';
import { imagePreviewUrl } from '../lib/images';

export function MediaLibraryPage() {
  const { data } = useSites();
  const site = data?.sites[0];

  const list = useMediaList(site?.id);
  const uploadMedia = useUploadMedia(site?.id ?? '');
  const deleteMedia = useDeleteMedia(site?.id ?? '');

  if (!site) return <div className="p-8">No site selected.</div>;

  const media = list.data?.media ?? [];

  return (
    <div className="p-8 max-w-4xl">
      <div className="flex items-center justify-between mb-1">
        <h1 className="text-2xl font-bold">Media Library</h1>
        <label>
          <span className="px-3 py-1.5 rounded text-sm bg-gray-900 text-white hover:bg-gray-800 cursor-pointer">
            {uploadMedia.isPending ? 'Uploading…' : '+ Upload image'}
          </span>
          <input
            type="file"
            accept="image/*"
            className="hidden"
            disabled={uploadMedia.isPending}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) uploadMedia.mutate(file);
              e.target.value = '';
            }}
          />
        </label>
      </div>
      <p className="text-gray-600 mb-6">Upload and manage the images used across your site.</p>

      {uploadMedia.error && <div className="text-sm text-red-600 mb-3">{(uploadMedia.error as Error).message}</div>}

      {list.isLoading ? (
        <p className="text-gray-500">Loading…</p>
      ) : media.length === 0 ? (
        <div className="bg-white rounded shadow p-10 text-center text-gray-500">
          No images yet. Upload your first image to get started.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {media.map((asset) => (
            <div key={asset.id} className="bg-white border rounded overflow-hidden">
              <img
                src={imagePreviewUrl(asset.key, { width: 320, height: 240, fit: 'cover' })}
                alt={asset.filename ?? ''}
                className="w-full h-32 object-cover"
              />
              <div className="p-2">
                <p className="text-xs text-gray-600 truncate" title={asset.filename ?? asset.key}>
                  {asset.filename ?? asset.key}
                </p>
                <button
                  type="button"
                  className="text-red-600 text-xs mt-1 hover:underline"
                  disabled={deleteMedia.isPending}
                  onClick={() => deleteMedia.mutate(asset.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
